import script from "./AdminImagePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminImagePreview.vue?vue&type=script&setup=true&lang=ts"

import "./AdminImagePreview.vue?vue&type=style&index=0&id=297d9dfa&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297d9dfa"]])

export default __exports__